import './IconAlert.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
const IconAlert = _ref => {
  let {
    width = 22.348,
    height = 20,
    className,
    fill
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 22.348 20",
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15731",
    "data-name": "Group 15731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15730",
    "data-name": "Group 15730",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6988",
    "data-name": "Path 6988",
    d: "M20.912,25H3.592a2.471,2.471,0,0,1-2.243-1.117,2.471,2.471,0,0,1,.154-2.5l8.659-15A2.473,2.473,0,0,1,12.252,5a2.472,2.472,0,0,1,2.089,1.384l8.659,15a2.471,2.471,0,0,1,.155,2.5A2.472,2.472,0,0,1,20.912,25ZM12.252,6.82c-.119,0-.323.146-.512.474l-8.66,15c-.189.327-.214.578-.154.68s.288.206.667.206H20.912c.378,0,.607-.1.667-.207s.034-.353-.155-.68l-8.659-15C12.575,6.967,12.371,6.82,12.252,6.82Z",
    transform: "translate(-1.078 -5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15732",
    "data-name": "Group 15732",
    transform: "translate(12.207 16.047) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(0.183 3.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M.913,0A.93.93,0,0,0,0,.947V5.122a.93.93,0,0,0,.913.947.93.93,0,0,0,.913-.947V.947A.93.93,0,0,0,.913,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: "1.095",
    cy: "1.095",
    r: "1.095"
  }))));
};
const StyledSVG = /*#__PURE__*/styled("svg")({
  name: "StyledSVG",
  class: "sweck4b"
});
export default IconAlert;